// Types for OpenAPI spec parsing

export type OpenAPISpec = {
  openapi: string
  info: {
    title: string
    version: string
    description?: string
  }
  servers?: Array<{
    url: string
    description?: string
  }>
  paths: Record<string, PathItem>
  components?: {
    schemas?: Record<string, Schema>
    securitySchemes?: Record<string, SecurityScheme>
  }
}

export type PathItem = {
  get?: Operation
  post?: Operation
  put?: Operation
  patch?: Operation
  delete?: Operation
  options?: Operation
  head?: Operation
  trace?: Operation
}

export type Operation = {
  summary?: string
  description?: string
  operationId?: string
  tags?: string[]
  security?: Array<Record<string, string[]>>
  parameters?: Parameter[]
  requestBody?: RequestBody
  responses?: Record<string, Response>
  'x-premium-required'?: boolean
}

export type Parameter = {
  name: string
  in: 'query' | 'path' | 'header' | 'cookie'
  required?: boolean
  description?: string
  schema?: Schema
}

export type RequestBody = {
  description?: string
  required?: boolean
  content?: Record<string, MediaType>
}

export type Response = {
  description: string
  content?: Record<string, MediaType>
}

export type MediaType = {
  schema?: Schema
}

export type Schema = {
  type?: string
  properties?: Record<string, Schema>
  items?: Schema
  enum?: unknown[]
  required?: string[]
  description?: string
  example?: unknown
  format?: string
  nullable?: boolean
  $ref?: string
}

export type SecurityScheme = {
  type: string
  scheme?: string
  bearerFormat?: string
  description?: string
}

export interface EndpointInfo {
  method: HttpMethod
  path: string
  summary: string
  description?: string
  operationId?: string
  tags?: string[]
  parameters?: Parameter[]
  requestBody?: RequestBody
  responses?: Record<string, Response>
  security?: Array<Record<string, string[]>>
  isPremium?: boolean
}

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS' | 'HEAD' | 'TRACE'

export type MethodBadgeColor = {
  background: string
  text: string
}

export const METHOD_COLORS: Record<HttpMethod, MethodBadgeColor> = {
  GET: { background: '#22c55e20', text: '#16a34a' },
  POST: { background: '#3b82f620', text: '#2563eb' },
  PUT: { background: '#f59e0b20', text: '#d97706' },
  PATCH: { background: '#8b5cf620', text: '#7c3aed' },
  DELETE: { background: '#ef444420', text: '#dc2626' },
  OPTIONS: { background: '#6b728020', text: '#4b5563' },
  HEAD: { background: '#06b6d420', text: '#0891b2' },
  TRACE: { background: '#ec489920', text: '#db2777' },
}
